<template>
  <basic-container>
    <avue-crud
      :page.sync="page"
      :data="tableDatas"
      :option="tableOption"
      :table-loading="tableLoading"
      @on-load="onLoad"
      @refresh-change="onLoad"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDelete"
    >
      <template slot="modelName" slot-scope="scope">
        <el-link type="primary" :href="'#/dws/datamodel/database/' + scope.row.id">{{scope.row.modelName}}</el-link>
      </template>
    </avue-crud>
  </basic-container>
</template>
<script>
import { 
  listDataModel,
  createDataModel,
  updateDataModel,
  deleteDataModel
} from "@/api/dws/datamodel";

export default {
  data(){
    return {
      page: {
          pageSizes: this.$store.state.common.pageSizes,
        pagerCount: this.$store.state.common.pagerCount,
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      tableLoading: false,
      tableDatas: [],
      tableOption: {
        labelWidth:110,
        column:[
          {
            label:'模型名称',
            width:200,
            prop:'modelName',
            rules: [{
              required: true,
              message: "请输入模型名称",
              trigger: "blur"
            }],
          },
          {
            label:'描述',
            prop:'modelDesc',
            type: "textarea",
            minRows: 2,
            span: 24
          },
          {
            label:'状态',
            prop:'entableStatus',
            type: "radio",
            rules: [{
              required: true,
              message: "请选择状态",
              trigger: "blur"
            }],
            dicData: [
              {
                label: '启用',
                value: '1'
              },
              {
                label: '禁用',
                value: '0'
              }
            ]
          }
        ]
      }
    }
  },
  methods: {
    onLoad(){
      this.tableLoading = true;
      let params = {
        modelName:'',
        pageNo:this.page.currentPage,
        pageSize:this.page.pageSize
      };
      listDataModel(params).then(
        res => {
          this.tableDatas = res['data']['data']['lists'];
          this.page.total = res['data']['data']['totalCount'];
          this.tableLoading = false;
        }
      ).catch(() => {
        this.tableDatas = [];
        this.tableLoading = false;
        this.page.total = 0;
      });
    },
    rowSave(row , done){
      createDataModel(row).then(
        res => {
          this.onLoad();
          this.$message.success(res.data['msg'] || '成功');
          done();
        }
      ).catch(() => {
        done();
        this.$message.error('失败')
      })
    },
    rowUpdate(row, index , done){
      updateDataModel(row).then(
        res => {
          this.onLoad();
          this.$message.success(res.data['msg'] || '成功');
          done();
        }
      ).catch(() => {
        done();
        this.$message.error('失败')
      })
    },
    rowDelete(row , index){
      this.$confirm(`确定要删除${row.modelName}？` , `删除模型` , {
        type: 'warning',
        beforeClose: (action , instance , done) => {
          if(action === 'confirm'){
            deleteDataModel({
              id: row.id
            }).then(
              () => {
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
                this.onLoad();
                done();
              }
            ).catch(() => {
              done();
            })
          }else{
            done();
          }
        }
      });
    }
  }
}
</script>